export function fetchProfile() {
  return window.axios.get('/profile');
}

export function patchProfile(data) {
  return window.axios.patch('/profile', data);
}
